import { NotifyHelper } from 'classes/helpers/notify.helper';
import { Controller } from 'lib_ts/enums/routing/controllers';
import { AdminBurnInTestsRoutes } from 'lib_ts/enums/routing/routes/admin-burn-in-tests';
import { IBurnInTest } from 'lib_ts/interfaces/i-burn-in-test';
import { BaseRESTService } from 'services/_base-rest.service';

export class AdminBurnInTestsService extends BaseRESTService {
  private static instance: AdminBurnInTestsService;
  static getInstance(): AdminBurnInTestsService {
    if (!AdminBurnInTestsService.instance) {
      AdminBurnInTestsService.instance = new AdminBurnInTestsService();
    }

    return AdminBurnInTestsService.instance;
  }

  private constructor() {
    super({
      controller: Controller.MachineBurnInTests,
    });
  }

  async search(filter: Partial<IBurnInTest>): Promise<IBurnInTest[]> {
    return await this.post(
      {
        uri: AdminBurnInTestsRoutes.Search,
      },
      filter
    )
      .then((result) => result)
      .catch((reason) => {
        console.error(reason);
        NotifyHelper.error({
          message_md: 'There was an error while searching for burn-in tests.',
        });
        return [];
      });
  }

  async getOne(id: string): Promise<IBurnInTest | undefined> {
    return this.get({
      uri: id,
    })
      .then((result) => {
        if (!result) {
          NotifyHelper.warning({
            message_md: 'There was an error while fetching burn-in test.',
          });
          return [];
        }

        return result;
      })
      .catch((reason) => {
        console.error(reason);
        NotifyHelper.error({
          message_md: 'There was an error while fetching burn-in test.',
        });
        return undefined;
      });
  }

  async postOne(
    payload: Partial<IBurnInTest>
  ): Promise<IBurnInTest | undefined> {
    return this.post(
      {
        uri: '',
      },
      payload
    )
      .then((result) => {
        if (!result) {
          NotifyHelper.warning({
            message_md: 'There was an error while creating burn-in test.',
          });
          return undefined;
        }

        return result;
      })
      .catch((reason) => {
        console.error(reason);
        NotifyHelper.error({
          message_md: 'There was an error while creating burn-in test.',
        });
        return undefined;
      });
  }

  async putOne(
    id: string,
    payload: Partial<IBurnInTest>
  ): Promise<IBurnInTest | undefined> {
    return this.put(
      {
        uri: id,
      },
      payload
    )
      .then((result) => {
        if (!result) {
          NotifyHelper.warning({
            message_md: 'There was an error while updating burn-in test.',
          });
          return undefined;
        }

        return result;
      })
      .catch((reason) => {
        console.error(reason);
        NotifyHelper.error({
          message_md: 'There was an error while updating burn-in test.',
        });
        return undefined;
      });
  }

  async deleteOne(id: string): Promise<boolean> {
    return this.delete({
      uri: id,
    })
      .then(() => true)
      .catch((reason) => {
        console.error(reason);
        NotifyHelper.error({
          message_md: 'There was an error while deleting burn-in test.',
        });
        return false;
      });
  }
}
